import React from 'react'
import './HomeNosotros.scss'
import { DobleGuion } from './DobleGuion'
import { Link } from 'react-router-dom';

export const HomeNosotros = () => {

    return (
        <div className="nosotros-container">
            <div className="image">
                <img src="/static/img/nosotros.jpg" alt="" />
            </div>
            <div className="information-botones">
                <div className="information">
                    <div className="title"><p>Nosotros</p> <DobleGuion /></div>
                    <div className="text">
                        <p>Llevamos más de 60 años rodeados de macetas,</p>
                        <p>aunando primero esfuerzos en industrializar un sector eminentemente artesanal,</p>
                        <p>diversificando después con nuevos materiales, diseños  y funcionalidades,</p>
                        <p>forjando alianzas y, más recientemente,</p>
                        <p>contribuyendo a un modelo económico circular y sostenible.</p>
                    </div>
                </div>
                <div className="botones">
                    <div className="boton">
                        <div className="btn"><Link to="/empresa">CONÓCENOS</Link></div>
                    </div>
                </div>
            </div>

        </div>
    )
}